import { useContext } from "react";
import { ModalSettingContext } from "../../../../index";
import CheckboxViolet from "@UI/New/ChecboxViolet/CheckboxViolet";

export const InRecording = () => {
    const { state, setFieldInState} = useContext(ModalSettingContext);

    return (
        <CheckboxViolet 
            value={state?.inRecording} 
            setValue={(value) => setFieldInState({ field: 'inRecording', value})}
            takePassedValue
            text='Занятие в записи'
        />
    );
};